module.exports = __webpack_public_path__ + "static/media/sustainable.c190c7c7.png";